import inDepthSectionNav from './in-depth/section-nav.index';
import reactRenderer from './react-renderer';
import dataVizEvents from '../lib/data-viz-events';

dataVizEvents();
reactRenderer.add(inDepthSectionNav);
